import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { useFormik, FormikProvider, FieldArray } from "formik";
import {  Apitoken, Authtoken } from "../Global";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
const DecaySaleAdd = () => {


  const [menu, setMenu] = useState(false);
  const [backendErrors, setBackendErrors] = useState([]);
  const [customersList, setCustomersList] = useState([]);  
  const [productLists, setproductLists] = useState([]);
  const [paymentMethods, setPaymentMethods] = useState([]);  
  const [paymentStatus, setPaymentStatus] = useState([]);
  const [currencySymbol, setCurrencySymbol] = useState('dh');
  const [permission, setPermission] = useState({});

 
  const [showTableHeadings, setShowTableHeadings] = useState(false);

  // const customFuction = (event) =>{
  //   var index = event.target.selectedIndex;
  //   var optionElement = event.target.childNodes[index];
  //   var key_sybmol =  optionElement.getAttribute('key_sybmol');
  //   console.log(key_sybmol);
  //   setCurrencySymbol(key_sybmol)
   
  // }
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const handleSelectChange = (name, selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    updateFormikValue(name, value);
    customHandleInput({ target: { name, value } });
  };
  
  const updateFormikValue = (name, value) => {
    formik.setFieldValue(name, value);
  };
  const currentDateTime = (getCurrentDateTime);

  function getCurrentDateTime() {
    const now = new Date();
    const year = now.getFullYear();
    const month = `${(now.getMonth() + 1) < 10 ? '0' : ''}${now.getMonth() + 1}`;
    const day = `${now.getDate() < 10 ? '0' : ''}${now.getDate()}`;
    const hours = `${now.getHours() < 10 ? '0' : ''}${now.getHours()}`;
    const minutes = `${now.getMinutes() < 10 ? '0' : ''}${now.getMinutes()}`;
    
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  } 
  const formik = useFormik({
    initialValues: {
      date_time: currentDateTime,
      product: "",
      quantity: "",
      price: "",
      decay_customer: "",
      payment_method: "",
      payment_status:"",
      note:"",
      currency:"4",
      items:[]
    },
    onSubmit: (values,{ setSubmitting }) => {
      //alert(JSON.stringify(values, null, 2));
      axios
        .post("/decay-sales/add", values, {
          headers: {
             Authorization: `Bearer ${Authtoken}`,
             Apitoken: Apitoken,
             "Content-Type": "multipart/form-data",
            },
        })
        .then((response) => {
          
          delete backendErrors['error'];
          setSubmitting(false);
         // actions.setSubmitting(false);
         $("#form-submit").text("Add Decay Sale");
          if (response.data.code === 200) {
            toast.success(response.data.message);
         //   actions.resetForm();
            setTimeout(() => {
              window.location.href = "/decay-sales";
            }, 1000);
          }  else if (response.data.code === 422) {
              setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
          }
          else {
             setBackendErrors(response.data.error);
          }
        })
        .catch((error) => {
          toast.error(error);
        });
    },
  });
 const primaryCurrency =  [
    {
        "label": "EUR",
        "value": 1,
        "symbol": "€",
        "key": "cabrane-0"
    },
    {
        "label": "USD",
        "value": 2,
        "symbol": "$",
        "key": "cabrane-1"
    },
    {
        "label": "GBP",
        "value": 3,
        "symbol": "£",
        "key": "cabrane-2"
    },
    {
        "label": "MAD ",
        "value": 4,
        "symbol": "dh",
        "key": "cabrane-3"
    }
];
 
  useEffect(() => {
        setPermission(FindModuleById(281)); 
console.log(permission);

    setCurrencySymbol('dh');
   
    
    axios
      .get(`/helpers/decay-sale-status`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let materials_payment_status = response.data.data.status;
          let productslisting = materials_payment_status.map((customer, index) => ({
            label: customer.title,
            value: customer.id,
            key: `address-${index}`,
          }));
          setPaymentStatus(productslisting);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });
    
    axios
    .post(
      "/products/listing-category-type", 
      {},
      {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      }
    )
    .then((response) => {
      if (response.data.code === 200) {
        let products = response.data.data.products;
        let productslisting = products.map((customer, index) => ({
          label: customer.productname,
          value: customer.id,
          key: `address-${index}`,
        }));
        setproductLists(productslisting);
      } else {
        console.log("API response is not an array");
      }
    })
    .catch((error) => {
      console.log(error);
    });

      axios
      .get(`/helpers/expenses-payment-methods`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let types = response.data.data.methods;
          let typeslisting = types.map((ord, index) => ({
            label: ord.title,
            value: ord.id,
            key: `location-${index}`,
          }));
          setPaymentMethods(typeslisting);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });

      
    axios
    .post(
      "/decay-customers/listing", {},
      {
        headers: {
          Authorization: `Bearer ${Authtoken}`,
          Apitoken: Apitoken,
        },
      }
    )
    .then((response) => {
      if (response.data.code === 200) {
        let suppliers = response.data.data.customers;
        let supplierslist = suppliers.map((cat, index) => ({
          label: cat.name,
          value: cat.id,
          key: `categories-${index}`,
        }));
        setCustomersList(supplierslist);
      } else {
        console.log("API response is not an array");
      }
    })
    .catch((error) => {
      console.log(error);
    });

}, []);

  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };

  // const onChangeHandler = (event) => {
  //   console.log(event.target.files[0]);

  //   formik.values.invoice = event.target.files[0];

  // }
  console.log(productLists);
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Decay Sale</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/decay-sales">Decay Sales</Link>
                    </li>
                    <li className="breadcrumb-item active">Add Decay Sale</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Decay Sale Information</h4>
                    {permission && permission.add == 1 && (
                      <FormikProvider value={formik}>
                      <form onSubmit={formik.handleSubmit}>
                     
                        <div className="row">
                          <div className="col-md-6">
                          <div className="form-group">
                              <label>Date And Time</label>
                              <input
                                type="datetime-local"
                                name="date_time"
                                value={formik.values.date_time}
                                className={
                                  backendErrors.date_time
                                    ? "form-input form-control input-error datetimepicker"
                                    : "form-input form-control datetimepicker"
                                }
                                onChange={(e) => {
                                  formik.handleChange(e);
                                  customHandleInput(e);
                                }}
                                 onBlur={formik.handleBlur}
                              />
                              <small>
                                {backendErrors.date_time && (
                                    <span className="form-error mt-1">
                                      {backendErrors.date_time}
                                    </span>
                                  )}
                              </small>
                            </div>
                       </div>
                       
                          <div className="col-md-6">
                            <div className="form-group status2">
                              <label>Select Currency</label>
                              <Select
                                className="w-100"
                                value={primaryCurrency.find(option => option.value == formik.values.currency) || null} // Ensure correct format
                                name="currency"
                                 onChange={(selectedOption) => handleSelectChange("currency", selectedOption)}
                                onBlur={formik.handleBlur}
                                options={primaryCurrency}
                                placeholder="Select"

                                  
                                />
                             
                              <small>
                                {backendErrors.currency && (
                                    <span className="form-error mt-1">
                                      {backendErrors.currency}
                                    </span>
                                  )}
                              </small>
                              </div>
                             
                            </div>
                          
                          
                          <div className="col-md-6">
                            <div className="form-group status">
                                <label>Select Decay Customer</label>
                                <Select
                                className="w-100"
                                value={customersList.find(option => option.value == formik.values.decay_customer) || null} // Ensure correct format
                                name="decay_customer"
                                 onChange={(selectedOption) => handleSelectChange("decay_customer", selectedOption)}
                                onBlur={formik.handleBlur}
                                options={customersList}
                                placeholder="Select"

                                 
                                />
                                <small>
                                  {backendErrors.decay_customer && (
                                      <span className="form-error mt-1">
                                        {backendErrors.decay_customer}
                                      </span>
                                    )}
                                </small>
                              </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group status">
                                <label>Select Payment Method</label>
                                <Select
                                 className="w-100"
                                 value={paymentMethods.find(option => option.value == formik.values.payment_method) || null} // Ensure correct format
                                 name="payment_method"
                                  onChange={(selectedOption) => handleSelectChange("payment_method", selectedOption)}
                                 onBlur={formik.handleBlur}
                                 options={paymentMethods}
                                 placeholder="Select"

                                 
                                />
                                <small>
                                  {backendErrors.payment_method && (
                                      <span className="form-error mt-1">
                                        {backendErrors.payment_method}
                                      </span>
                                    )}
                                </small>
                              </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group status">
                                <label>Select Payment Status</label>
                                <Select
                                 className="w-100"
                                 value={paymentStatus.find(option => option.value == formik.values.payment_status) || null} // Ensure correct format
                                 name="payment_status"
                                  onChange={(selectedOption) => handleSelectChange("payment_status", selectedOption)}
                                 onBlur={formik.handleBlur}
                                 options={paymentStatus}
                                 placeholder="Select"

                                />
                                <small>
                                  {backendErrors.payment_status && (
                                      <span className="form-error mt-1">
                                        {backendErrors.payment_status}
                                      </span>
                                    )}
                                </small>
                              </div>
                          </div>

                          <div className="col-md-6">
                          <div className="form-group">
                              <label>Note</label>
                              <input
                                type="text"
                                name="note"
                                value={formik.values.note}
                                className="form-input form-control"
                                onChange={(e) => {
                                  formik.handleChange(e);
                                  customHandleInput(e);
                                }}
                                onBlur={formik.handleBlur}
                              />
                              <small>
                                {backendErrors.note && (
                                    <span className="form-error mt-1">
                                      {backendErrors.note}
                                    </span>
                                  )}
                              </small>
                            </div>
                          </div>
                        </div>
                        <FieldArray
                          name="items"
                          render={(arrayHelpers) => (
                            <div style={{overflow:"auto2"}}>
                              <button
                                className="btn btn-primary mb-3"
                                type="button"
                                onClick={() => {
                                  let appendArr =arrayHelpers.form.values.items[0];
                                  let initialArr ={
                                    product: "",
                                    price: "",
                                    quantity: "",
                                   }
                                   appendArr = (appendArr)?appendArr:initialArr;
                                  arrayHelpers.push(appendArr);
                                  setShowTableHeadings(true);
                                 
                                }}
                              >
                                +
                              </button>

                              <table className="table table-padding">
                                {showTableHeadings && (
                                  <thead>
                                    <tr>
                                      <th >Product</th>
                                      <th>Price</th>
                                      <th >Quanity</th>
                                      <th  ></th>
                                   
                                    </tr>
                                  </thead>
                                )}
                                <tbody>
                                  {formik.values.items.map(
                                    (friend, index) => (
                                      <tr key={index}>
                                      
                                        <td  >
                                          <div className="form-group status">
                                            <Select
                                         
                                              name={`items[${index}].product`}
                                              options={productLists}
                                              value={productLists.find(option => option.value == formik.values.items[index].product) || null} // Ensure correct format
                                              onChange={(selectedOption) => {
                                                formik.setFieldValue(`items[${index}].product`, selectedOption.value); // ✅ Store only value in Formik
                                                customHandleInput({
                                                  target: {
                                                    name: `items[${index}].product`,
                                                    value: selectedOption.value, // ✅ Ensure only value is passed
                                                  },
                                                });
                                              }}
                                              onBlur={formik.handleBlur}
                                              placeholder="Select"
                                              className="w-100"

                                             
                                            />
                                          </div>
                                        </td>
                                     
                                    
                                        <td >
                                          <div className="form-group">
                                          
                                            <div className="input-group" >
                                                <input type="text"  
                                                name={`items[${index}].price`}
                                                onKeyPress={(event) => {
                                                  // Prevent non-numeric input for keypress
                                                  if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                                    event.preventDefault();
                                                  }
                                                }}
                                                value={
                                                  formik.values.items[index]
                                                    .price
                                                }
                                              
                                                onChange={(e) => {
                                                  formik.handleChange(e);
                                                }}
                                                onBlur={formik.handleBlur}
                                                className="form-control" placeholder="Price" aria-label="Price" aria-describedby="basic-addon2" />
                                                <div className="input-group-append">
                                                    <span className="input-group-text" id="basic-addon2">{currencySymbol}</span>
                                                </div>
                                            </div>
                                          </div>
                                        </td>
                                      
                                        <td >
                                          <div className="form-group">
                                          
                                            <div className="input-group" >
                                                <input type="text"  
                                                name={`items[${index}].quantity`}
                                                onKeyPress={(event) => {
                                                  // Prevent non-numeric input for keypress
                                                  if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                                    event.preventDefault();
                                                  }
                                                }}
                                                value={
                                                  formik.values.items[index]
                                                    .quantity
                                                }
                                              
                                                onChange={(e) => {
                                                  formik.handleChange(e);
                                                }}
                                                onBlur={formik.handleBlur}
                                                className="form-control" placeholder="Quantity" />
                                              
                                            </div>
                                          </div>
                                        </td>
                                       
                                        <td >
                                          <div className="form-group">
                                            <button
                                              className="btn btn-danger"
                                              // style={{ marginTop: 30 }}
                                              type="button"
                                              onClick={() =>
                                                arrayHelpers.remove(index)
                                              }
                                            >
                                              -
                                            </button>
                                          </div>
                                        </td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </table>
                            </div>
                          )}
                        />

                      
                        <div className="text-end mt-4">
                          <button className="btn btn-primary" type="submit" id="form-submit"  disabled={formik.isSubmitting}>
                          Add Decay Sale
                          </button>
                        </div>
                      </form>
                    </FormikProvider>
                    )}
                  
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default DecaySaleAdd;
